// 跨境商家需要校验商家资质才可以发货
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneButton, OneModal } from '@yy/one-ui'
import { useMemoizedFn } from '@/hooks/utilsHooks'
import { hasSellerAuthExpressType } from '@/services/apis'
import verifyingPic from '@/static/images/selling/verifying.png'
import { useSelector } from '@/store'
import { jumpToOneclub } from '@/utils/user'

const css = {
  content: {
    textAlign: 'center',
  },
  img: {
    display: 'block',
    width: '190px',
    margin: 'auto',
  },
  h1: {
    fontSize: '20px',
    lineHeight: '28px',
    marginTop: 0,
  },
  p: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#748399',
    width: '306px',
    margin: '10px auto 20px',
  },
}

// 服务申请
const applyService = () => {
  jumpToOneclub('serviceApply')
}

/**
 * 跨境商家需要校验商家资质才可以发货
 * @returns
 */
export const useServiceApplyCN = () => {
  const { t } = useTranslation()
  const { info } = useSelector((s) => s.user)

  return useMemoizedFn(async () => {
    if (info.selfArea === 'CN' && !info.hasSellerAuthExpressType) {
      const { data } = await hasSellerAuthExpressType()
      if (data.hasSellerAuthExpressType) return true
      if (data.hasAppApply)
        OneModal.confirm({
          width: '480px',
          content: (
            <div style={css.content}>
              <img src={verifyingPic} style={css.img} />
              <h1 style={css.h1}>{t('selling.setting.status.verifying')}</h1>
              <p style={css.p}>{t('serviceApply.reviewing')}</p>
              <OneButton onClick={applyService} type="primary">
                {t('subscribe.package.pendingBillModal.showDetail')}
              </OneButton>
            </div>
          ),
          cancelButtonProps: { style: { display: 'none' } },
          okButtonProps: { style: { display: 'none' } },
          closable: true,
          icon: null,
        })
      else
        OneModal.info({
          title: t('serviceApply.permission'),
          content: t('serviceApply.none'),
          okText: t('serviceApply.apply'),
          cancelText: t('common.cancelBtn'),
          cancelButtonProps: { style: { display: 'inline-block' } },
          okButtonProps: { type: 'primary' },
          onOk: () => {
            jumpToOneclub('createApply')
          },
        })

      return false
    }
    return true
  })
}
